import { forwardRef } from 'react';
import { useToggle } from '~/lib/use-toggle';
import { cn } from '~/lib/utils';
import { Button } from '~/components/ui/button';
import { Input, type InputProps } from '~/components/ui/input';
import { EyeClosedIcon, EyeOpenedIcon } from '~/icons';

// TODO: Use this component for all password inputs (sign in, password reset)
export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  ...props
}, ref) => {
  const visiblePassword = useToggle(false);
  return <div className="relative">
        <Input ref={ref} type={!visiblePassword.isActive ? 'password' : 'text'} {...props} autoComplete="off" className={cn('pr-10', className)} />
        <Button size="icon" type="button" variant="link" onClick={visiblePassword.toggle} className="absolute -top-1/2 right-1 translate-y-2/4 p-0 hover:bg-accent hover:no-underline">
          {visiblePassword.isActive ? <EyeClosedIcon /> : <EyeOpenedIcon />}
        </Button>
      </div>;
});
PasswordInput.displayName = 'PasswordInput';